import { FlyerDetailAddPageForm } from "./flyer-detail-add-page-form.interface";

export function createFlyerDetailAddPageForm(): FlyerDetailAddPageForm {
  return {
    templateId: -1,
  };
}
